import {useEventListener} from "@dp-instant/ui";
import {GameEvents} from "@game/coregame/GameEvents";
import {PlayerType} from "@game/coregame/interfaces/PlayerType";
import {useInjection} from "@dp-instant/ui";
import {ParticipantItem} from "@game/ui/interface/ParticipantItem";
import {TypesGame} from "@game/TypesGame";
import cn from "classnames";
import {useState} from "preact/hooks";
import {Participants} from "./Participants/Participants";
import "./ProgressBar.less";
import {ProgressIndicator} from "./ProgressIndicator/ProgressIndicator";
import {SkinManager} from "@game/coregame/managers/SkinManager";

type ProgressProps = {participants?: ParticipantItem[]};
type ProgressBarState = {
    items: {owner: PlayerType; count: number; area?: number; x?: number}[];
    totalValue: number;
};
export const ProgressBar = ({participants}: ProgressProps) => {
    const skinManager = useInjection<SkinManager>(TypesGame.skinManager);
    const [state, changeState] = useState({items: [], totalValue: 0} as ProgressBarState);
    useEventListener(GameEvents.STATS_UPDATED, changeState, participants);
    let offsetX = 0;
    const itemsToDisplay: [number, number, string][] = (state.items || []).map(item => {
        const itemArea = item.count / state.totalValue;
        const x = offsetX;
        offsetX += itemArea;
        //const [fillColor, unitColor] = GameColors.players[item.owner];
        const [fillColor, unitColor] = skinManager.getColorBy(item.owner);
        return [x, itemArea, fillColor];
    });

    return (
        <div class={cn("progress-bar")}>
            {participants ? <Participants users={participants} /> : null}
            <ProgressIndicator itemsToDiplay={itemsToDisplay} />
        </div>
    );
};
